module.exports = __webpack_public_path__ + "img/KinokoTable71.f379cd53.jpg";